import { render, staticRenderFns } from "./OptionFormDependencies.vue?vue&type=template&id=4ae05cc8"
import script from "./OptionFormDependencies.vue?vue&type=script&lang=ts"
export * from "./OptionFormDependencies.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports